import { ReportSection, ReportSectionItemContent } from '@/components';
import type { ProjectModel } from '@/features/project/projects/_models/project';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type Props = {
  project: z.infer<typeof ProjectModel>;
};

export const EvaluasiOlehPemerintahDesa: FC<Props> = ({ project }) => {
  const { t } = useTranslation();
  return (
    <>
      <ReportSection
        title={t('evaluasi-mandiri-oleh-pemerintah')}
        items={[
          {
            indexText: '23.',
            subtitle: t('evaluation-of-program-results'),
            item: (
              <ReportSectionItemContent
                value={project.indonesiaData?.evaluationOfProgramResults}
              />
            ),
          },
          {
            indexText: '24.',
            subtitle: t('improvement-suggestions'),
            item: (
              <ReportSectionItemContent
                value={project.indonesiaData?.usulanPerbaikan}
              />
            ),
          },
        ]}
      />
      <ReportSection
        title={t('referensi-program-serupa')}
        items={[
          {
            indexText: '25.',
            subtitle: t('related-program-for-other-ministry'),
            item: (
              <ReportSectionItemContent
                value={
                  project.indonesiaData?.referensiProgramYangSamaDiDaerahLain
                }
              />
            ),
          },
          {
            indexText: '26.',
            subtitle: t('catatan'),
            item: (
              <ReportSectionItemContent
                value={project.indonesiaData?.catatan}
              />
            ),
          },
        ]}
      />
    </>
  );
};
